/* common - mutation */
export const SET_COMMON_INFO = 'SET_COMMON_INFO';
/* common - action */
export const PRELOAD_IMGS = 'PRELOAD_IMGS';
export const FETCH_PAGE_INFO = 'FETCH_PAGE_INFO';


// WEBPACK FOOTER //
// ./src/store/types/common.js